// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zPy7","newExpiryDate":"styles_newExpiryDate__2AYiW","footer":"styles_footer__2JLDa"};